export const makeYear = () => {
    const d = new Date();
    return d.getFullYear();
}
